import ButtonConfirm from '@/components/ui/button-confirm-delet'
import { useDeleteCreditByID } from '@/lib/hooks/previdenciario'
import { useToast } from '@/lib/hooks/use-toast'

interface Props {
  creditId: string
  isDisabled?: boolean
  onSuccess?: (id: string) => void
}

export default function DetalhesDeCreditoDeleteBtn({ creditId, isDisabled, onSuccess }: Props) {
  const { toast } = useToast()
  const { mutate: deleteCredit } = useDeleteCreditByID()
  const handleDeleteCreditControl = (id: string) => {
    deleteCredit(id, {
      onSuccess: () => onSuccess && onSuccess(id),
      onError: error => {
        console.error(error)
        toast({
          variant: 'destructive',
          description: 'Houve um erro ao excluir o crédito.'
        })
      }
    })
  }

  return (
    <ButtonConfirm
      confirmText="Excluir crédito?"
      onSuccess={() => handleDeleteCreditControl(creditId)}
      successBtnText="Excluir"
      isDisabled={isDisabled}
    />
  )
}
